// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M10.4167 2.49999H6.5C5.09987 2.49999 4.3998 2.49999 3.86502 2.77247C3.39462 3.01216 3.01217 3.39461 2.77248 3.86501C2.5 4.39979 2.5 5.09986 2.5 6.49999V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H14.1667C14.9416 17.5 15.3291 17.5 15.647 17.4148C16.5098 17.1836 17.1836 16.5098 17.4148 15.647C17.5 15.3291 17.5 14.9416 17.5 14.1667M15.8333 6.66666V1.66666M13.3333 4.16666H18.3333M8.75 7.08332C8.75 8.0038 8.00381 8.74999 7.08333 8.74999C6.16286 8.74999 5.41667 8.0038 5.41667 7.08332C5.41667 6.16285 6.16286 5.41666 7.08333 5.41666C8.00381 5.41666 8.75 6.16285 8.75 7.08332ZM12.4917 9.93178L5.44262 16.34C5.04614 16.7005 4.84789 16.8807 4.83036 17.0368C4.81516 17.1721 4.86704 17.3064 4.96932 17.3963C5.08732 17.5 5.35523 17.5 5.89107 17.5H13.7133C14.9126 17.5 15.5123 17.5 15.9833 17.2985C16.5745 17.0456 17.0456 16.5745 17.2985 15.9833C17.5 15.5123 17.5 14.9126 17.5 13.7133C17.5 13.3098 17.5 13.108 17.4559 12.9201C17.4004 12.684 17.2941 12.4628 17.1444 12.272C17.0252 12.1202 16.8677 11.9941 16.5526 11.742L14.2215 9.87721C13.9062 9.62491 13.7485 9.49877 13.5748 9.45425C13.4218 9.41501 13.2607 9.42009 13.1104 9.4689C12.94 9.52427 12.7905 9.66011 12.4917 9.93178Z"
    />
  </svg>
);
const IconImagePlus = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconImagePlus;
